import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from "@/store";

const LoginPage = () => import(/* webpackChunkName: "auth" */ "@/pages/LoginPage.vue");
const Home = () => import(/* webpackChunkName: "home" */ "@/pages/Home.vue");
const RegisterPage = () => import(/* webpackChunkName: "users" */ "@/pages/RegisterPage.vue");
const UserList = () => import(/* webpackChunkName: "users" */ "@/pages/UserList.vue");
const UserUpdatePage = () => import(/* webpackChunkName: "users" */ "@/pages/UserUpdatePage.vue");
const InputPage = () => import(/* webpackChunkName: "devices" */ "@/pages/InputPage.vue");
const ManagerDevicePage = () => import(/* webpackChunkName: "devices" */ "@/pages/ManagerDevicePage.vue");
const AllDevicePage = () => import(/* webpackChunkName: "devices" */ "@/pages/AllDevicePage.vue");
const ChartPage = () => import(/* webpackChunkName: "dashboard" */ "@/pages/ChartPage.vue");
const ReportPage = () => import(/* webpackChunkName: "reports" */ "@/pages/ReportPage.vue");
const CategoryPage = () => import(/* webpackChunkName: "categories" */ "@/pages/CategoryPage.vue");
const MaintenanceHistoryPage = () => import(/* webpackChunkName: "maintenance" */ "@/pages/MaintenanceHistoryPage.vue");

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: '',
    component: ChartPage,
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    props: true
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    props: true
  },
  {
    path: '/registerpage',
    name: 'registerpage',
    component: RegisterPage,
    props: true
  },
  {
    path: '/userlist',
    name: 'userlist',
    component: UserList,
    props: true
  },
  {
    path: '/inputDevice',
    name: 'inputDevice',
    component: InputPage,
    props: true
  },
  {
    path: '/allDevicePage',
    name: 'allDevicePage',
    component: AllDevicePage,
    props: true
  },
  {
    path: '/managerDevicePage',
    name: 'ManagerDevicePage',
    component: ManagerDevicePage,
    props: true
  },
  {
    path: '/reportPage',
    name: 'reportPage',
    component: ReportPage,
    props: true
  },
  {
    path: '/chartPage',
    name: 'chartPage',
    component: ChartPage,
    props: true
  },
  {
    path: '/departments',
    name: 'departments',
    component: CategoryPage,
    meta: { category: 'departments' },
    props: true
  },
  {
    path: '/device-groups',
    name: 'device-groups',
    component: CategoryPage,
    meta: { category: 'device-groups' },
    props: true
  },
  {
    path: '/device-type-details',
    name: 'device-type-details',
    component: CategoryPage,
    meta: { category: 'device-type-details' },
    props: true
  },
  {
    path: '/maintenance-history',
    name: 'maintenance-history',
    component: MaintenanceHistoryPage,
    props: true
  },
  {
    path: '/userupdate/:id',
    name: 'userupdate',
    component: UserUpdatePage,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  if (to.name === 'login' && store.state.token) {
    return { name: 'home' }
  }
})

export default router
